<template>
  <v-dialog
    class="cate-dialog"
    width="350px"
    title="Add a new Content Category"
    :visible.sync="dialogVisible"
    :scrollbar="false"
    @closed="onClosed"
  >
    <el-form
      class="cate-form"
      ref="cateForm"
      :model="cateForm"
      :rules="cateFormRules"
    >
      <el-form-item label="Category Name" prop="name">
        <el-input
          placeholder="Please input category name"
          v-model="cateForm.name"
          maxlength="100"
        />
      </el-form-item>
    </el-form>
    <div slot="footer" class="action-footer">
      <el-button type="primary" @click="addCategory"> Submit </el-button>
      <el-button plain @click="dialogVisible = false"> Cancel </el-button>
    </div>
  </v-dialog>
</template>

<script>
import { trimValidate } from "@/utils/validator";
export default {
  name: "NewCategoryDialog",
  props: {
    visible: {
      type: Boolean,
      default: false,
      required: true,
    },
  },
  data() {
    return {
      dialogVisible: this.visible,
      cateForm: {
        name: "",
      },
      cateFormRules: {
        name: [
          {
            required: true,
            validator: trimValidate("Please input category name"),
            trigger: "blur",
          },
        ],
      },
    };
  },
  watch: {
    visible(value) {
      this.dialogVisible = value;
    },
    dialogVisible(value) {
      this.$emit("update:visible", value);
    },
  },
  methods: {
    onClosed() {
      this.dialogVisible = false;
      this.$refs.cateForm.resetFields();
      this.$emit("closed");
    },
    addCategory() {
      this.$refs.cateForm.validate((valid) => {
        if (valid) {
          this.axios
            .post("/content/addcategory", {
              name: this.cateForm.name.trim(),
            })
            .then(({ code, data, msg }) => {
              if (code === 200) {
                this.dialogVisible = false;
                this.$message.success("Add category successfully");
                this.$emit("success", data);
              } else {
                this.$message.error(msg);
              }
            });
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.cate-dialog {
  ::v-deep {
    .el-dialog__body {
      padding: 0px 20px;
    }
  }
  .action-footer {
    text-align: center;
  }
  .el-input {
    width: 100%;
  }
}
</style>
